// function that formats date in the format of "Oct 2, 2024"
const convertDateFormat = (dateString: string) => {
  if (!dateString) {
    return;
  }
  const date = new Date(dateString);
  const options: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric', year: 'numeric' }; // Specify type for TypeScript
  const formattedDate = date.toLocaleDateString('en-US', options);
  return formattedDate;
};

export default convertDateFormat;